export default __webpack_public_path__ + "assets/images/input-dd84b05f8efb39b1b5159388a6effe2c.jpg";